import { useCbhFlag } from "@src/appV2/FeatureFlags";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";

/**
 * Hook to check if the interactive support feature is enabled.
 * This feature allows workers to select a shift and report issues
 * through a guided support flow.
 */
export function useIsInteractiveSupportEnabled() {
  return useCbhFlag(CbhFeatureFlag.INTERACTIVE_SUPPORT_ENABLED, { defaultValue: false });
}
